/**
 * A single slot for the app-level reaction to an unexpected 401.
 *
 * The transport detects a 401 but must not decide what it means — that is the
 * normal response for an anonymous visitor — so each web app registers one
 * handler (`useUnauthorizedRedirect`) and `axiosUtils` notifies it.
 *
 * Deliberately free of `window`, React and the rsdk barrel so the `.native.ts`
 * and `.server.ts` transports can adopt the same contract without a cycle.
 */

export type UnauthorizedInfo = {
  method?: string;
  url: string;
};

type UnauthorizedHandler = (info: UnauthorizedInfo) => void;

let handler: UnauthorizedHandler | null = null;

export function setUnauthorizedHandler(next: UnauthorizedHandler | null): void {
  handler = next;
}

/**
 * Never throws: a failing handler must not corrupt the axios rejection chain
 * the original caller is still waiting on.
 */
export function notifyUnauthorized(info: UnauthorizedInfo): void {
  if (!handler) return;

  try {
    handler(info);
  } catch {
    // See above.
  }
}
